var map = {
	"./404.svg": "./src/assets/icons/404.svg",
	"./add.svg": "./src/assets/icons/add.svg",
	"./arrow/down.svg": "./src/assets/icons/arrow/down.svg",
	"./arrow/left.svg": "./src/assets/icons/arrow/left.svg",
	"./arrow/right.svg": "./src/assets/icons/arrow/right.svg",
	"./arrow/up.svg": "./src/assets/icons/arrow/up.svg",
	"./bold.svg": "./src/assets/icons/bold.svg",
	"./caret/down.svg": "./src/assets/icons/caret/down.svg",
	"./caret/left.svg": "./src/assets/icons/caret/left.svg",
	"./caret/right.svg": "./src/assets/icons/caret/right.svg",
	"./caret/up.svg": "./src/assets/icons/caret/up.svg",
	"./check-circle.svg": "./src/assets/icons/check-circle.svg",
	"./check.svg": "./src/assets/icons/check.svg",
	"./check/rounded.svg": "./src/assets/icons/check/rounded.svg",
	"./check/square.svg": "./src/assets/icons/check/square.svg",
	"./chevron-down.svg": "./src/assets/icons/chevron-down.svg",
	"./chevron-left.svg": "./src/assets/icons/chevron-left.svg",
	"./chevron-right.svg": "./src/assets/icons/chevron-right.svg",
	"./chevron-up.svg": "./src/assets/icons/chevron-up.svg",
	"./chevron/down.svg": "./src/assets/icons/chevron/down.svg",
	"./chevron/left.svg": "./src/assets/icons/chevron/left.svg",
	"./chevron/right.svg": "./src/assets/icons/chevron/right.svg",
	"./chevron/up.svg": "./src/assets/icons/chevron/up.svg",
	"./code.svg": "./src/assets/icons/code.svg",
	"./collection.svg": "./src/assets/icons/collection.svg",
	"./desktop-preview.svg": "./src/assets/icons/desktop-preview.svg",
	"./dots/horizontal.svg": "./src/assets/icons/dots/horizontal.svg",
	"./dots/vertical.svg": "./src/assets/icons/dots/vertical.svg",
	"./edit.svg": "./src/assets/icons/edit.svg",
	"./feature-limited-time.svg": "./src/assets/icons/feature-limited-time.svg",
	"./file-text.svg": "./src/assets/icons/file-text.svg",
	"./go-deeper-arrow.svg": "./src/assets/icons/go-deeper-arrow.svg",
	"./go-deeper.svg": "./src/assets/icons/go-deeper.svg",
	"./h2.svg": "./src/assets/icons/h2.svg",
	"./image-upload.svg": "./src/assets/icons/image-upload.svg",
	"./image.svg": "./src/assets/icons/image.svg",
	"./info.svg": "./src/assets/icons/info.svg",
	"./italic.svg": "./src/assets/icons/italic.svg",
	"./keep-reading.svg": "./src/assets/icons/keep-reading.svg",
	"./latest-stories.svg": "./src/assets/icons/latest-stories.svg",
	"./layout.svg": "./src/assets/icons/layout.svg",
	"./link.svg": "./src/assets/icons/link.svg",
	"./list-ordered.svg": "./src/assets/icons/list-ordered.svg",
	"./list.svg": "./src/assets/icons/list.svg",
	"./loader.svg": "./src/assets/icons/loader.svg",
	"./lock.svg": "./src/assets/icons/lock.svg",
	"./log-out.svg": "./src/assets/icons/log-out.svg",
	"./mail.svg": "./src/assets/icons/mail.svg",
	"./menu.svg": "./src/assets/icons/menu.svg",
	"./mobile-preview.svg": "./src/assets/icons/mobile-preview.svg",
	"./more-horizontal.svg": "./src/assets/icons/more-horizontal.svg",
	"./newsletter.svg": "./src/assets/icons/newsletter.svg",
	"./paragraph.svg": "./src/assets/icons/paragraph.svg",
	"./pilcrow.svg": "./src/assets/icons/pilcrow.svg",
	"./plus.svg": "./src/assets/icons/plus.svg",
	"./private.svg": "./src/assets/icons/private.svg",
	"./quote-decoration.svg": "./src/assets/icons/quote-decoration.svg",
	"./quote.svg": "./src/assets/icons/quote.svg",
	"./read-another.svg": "./src/assets/icons/read-another.svg",
	"./refresh.svg": "./src/assets/icons/refresh.svg",
	"./save-story-filled.svg": "./src/assets/icons/save-story-filled.svg",
	"./save-story.svg": "./src/assets/icons/save-story.svg",
	"./search.svg": "./src/assets/icons/search.svg",
	"./settings.svg": "./src/assets/icons/settings.svg",
	"./settings/special-features.svg": "./src/assets/icons/settings/special-features.svg",
	"./settings/tags.svg": "./src/assets/icons/settings/tags.svg",
	"./settings/trending-topics.svg": "./src/assets/icons/settings/trending-topics.svg",
	"./settings/users.svg": "./src/assets/icons/settings/users.svg",
	"./social/facebook.svg": "./src/assets/icons/social/facebook.svg",
	"./social/get-link.svg": "./src/assets/icons/social/get-link.svg",
	"./social/linkedin.svg": "./src/assets/icons/social/linkedin.svg",
	"./social/twitter.svg": "./src/assets/icons/social/twitter.svg",
	"./story.svg": "./src/assets/icons/story.svg",
	"./tag.svg": "./src/assets/icons/tag.svg",
	"./text.svg": "./src/assets/icons/text.svg",
	"./type.svg": "./src/assets/icons/type.svg",
	"./user.svg": "./src/assets/icons/user.svg",
	"./users.svg": "./src/assets/icons/users.svg",
	"./x-circle.svg": "./src/assets/icons/x-circle.svg",
	"./x.svg": "./src/assets/icons/x.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";